import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Button } from "../../../Buttons/Button";
import { Input } from "../../Input";
import { confirmResetPasswordSchema } from "../../validations/emailPassword";

export function ConfirmResetPasswordForm({ onSubmit, isLoading }) {
  const { handleSubmit, control } = useForm({
    resolver: yupResolver(confirmResetPasswordSchema),
  });
  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="grid grid-cols-1 gap-y-4 sm:grid-cols-1"
    >
      <div className="sm:col-span-2">
        <Input name="password" label="New Password" control={control} inputSize="xl" type="password" />
      </div>
      <div className="sm:col-span-2">
        <Input
          name="confirmPassword"
          label="Confirm Password"
          type="password"
          control={control}
          inputSize="xl"
        />
      </div>
      <div className="mt-4">
        <Button
          text="Continue"
          type="submit"
          className="w-full flex justify-center min-h-[40px]"
          shape="default"
          isLoading={isLoading}
        />
      </div>
    </form>
  );
}
